export enum EPickupInStoreStatus {
  TO_BE_RECEIVED = 'to_be_received',
  TO_BE_DELIVERED = 'to_be_delivered',
  TO_BE_RETURNED = 'to_be_returned',
  DELIVERED = 'delivered',
  RETURNED = 'returned',
}
